<template>
  <v-form ref="serviceGroupCreationForm" v-model="isValid" v-show="visible">
    <v-text-field
      v-model="newServiceGroup.title"
      label="Title"
      :rules="titleRules"
      required
    ></v-text-field>
    <v-select
      :items="availableColorSchemes"
      v-model="newServiceGroup.colorScheme"
      placeholder="Select color"
      item-text="title"
      item-value="color"
      clearable>
      <template slot="item" slot-scope="data">
        <v-list-tile-content>
          <v-list-tile-title>
            <i class="fas fa-square-full" v-bind:style="{ color: data.item.color}"></i>
            <span class="ml-2 color-scheme-title">{{data.item.title}}</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </template>
      <template slot="selection" slot-scope="data">
        <v-list-tile-content>
          <v-list-tile-title>
            <i class="fas fa-square-full" v-bind:style="{ color: data.item.color}"></i>
            <span class="ml-2 color-scheme-title">{{data.item.title}}</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </template>
    </v-select>
    <v-alert
      :value="hasError"
      type="error"
      outline
    >
      {{ errorMessage }}
    </v-alert>
    <v-btn
      :disabled="!isValid"
      @click="handleOkClick"
    >
      Create
    </v-btn>
    <v-btn @click="handleCancelClick">Cancel</v-btn>
  </v-form>
</template>

<script>
import _ from 'lodash'
import {extractErrorToString} from '../../helpers/api'
import { mapState, mapActions } from 'vuex'

const emptyServiceGroup = {
  title: null,
  colorScheme: null
}

export default {
  name: 'service-group-creation-form',
  props: {
    visible: {
      type: Boolean
    }
  },
  data () {
    return {
      hasError: null,
      isValid: false,
      errorMessage: null,
      newServiceGroup: _.clone(emptyServiceGroup),
      titleRules: [
        v => !!v || 'Enter service group title',
        v => (v && v.length <= 255) || 'The length of the name should be no more than 255 characters'
      ]
    }
  },
  computed: {
    ...mapState({
      availableColorSchemes: 'availableColorSchemes'
    })
  },
  methods: {
    ...mapActions({
      serviceGroupsCreate: 'serviceGroupsCreate'
    }),
    async handleOkClick () {
      this.hasError = null
      this.errorMessage = null

      try {
        await this.serviceGroupsCreate(this.newServiceGroup)
        this.resetNewServiceGroup()
        this.$emit('close')
      } catch (e) {
        this.hasError = true
        this.errorMessage = extractErrorToString(e, 'Unable to create service group')
      }
    },
    handleCancelClick () {
      this.resetNewServiceGroup()
      this.$emit('close')
    },
    resetNewServiceGroup () {
      this.hasError = null
      this.errorMessage = null
      this.$refs.serviceGroupCreationForm.reset()
      this.newServiceGroup = _.clone(emptyServiceGroup)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/ServiceGroupCreationForm.vue